<template>
  <div>
    <div class="container clearfix">
      <div class="shadow-wrapper padding-m mb-s">
        <h3 class="mb-s">投保資料</h3>
        <OddVerThTable 
          :rows="insuInfoBasic"
        />
      </div>
      <div class="shadow-wrapper padding-m mb-s">
        <h3 
          class="mb-s"
          v-text="blockTitleOfUser"
        />
        <EvenVerThTable 
          class="mb-m" 
          :rows="insuInfoUser"
        />
      <div v-if="insuType!='pet'">
        <h3 
          class="mb-s"
          v-text="blockTitleOfMore"
        />  
        <EvenVerThTable 
          class="mb-s" 
          :rows="insuInfoOfMore"
        />
      </div>
      </div>
      <div class="shadow-wrapper padding-m mb-s">
        <h3 class="mb-s">相關條文 
          <span 
            class="tips-primary fz-small"
          >（請閱覽並確認）</span>
        </h3>
        <div 
          v-for="key in Object.keys(docs)"
          :key="key"
          class="flex-bc"
        >
          <Checkbox
            v-model="docs[key].isAgree"
            size="large" 
            @on-change="checkAfterRead(docs[key].isAgree,key)"
          />
          <span class="checkout-agree-checkbox-label">
              我已了解
              <span 
                v-if="docs[key].url === undefined"
                class="tips-primary pdf-link" 
                @click="docs[key].modal = true,docs[key].isAgree = true"
                v-text="docs[key].label"
              />
          </span>
        </div>
      </div>
      <div class="pull-right">
        <Button
          class="btn-m"
          :style="{marginRight: '10px'}"
          @click="back"
          v-text="'上一步'"
        />
        <Button
          class="btn-m btn-primary"
          :disabled="!agreeAll"
          @click="next"
          v-text="'下一步'"
        />
      </div>
      
    </div>
    <KYCModal v-model="docs.kyc.modal" />
    <analyticsReportModal v-model="docs.analytics.modal" />
    <PersonalInfoStatementModal v-model="docs.statement.modal" />
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { Button, Checkbox,Spin } from 'iview';
  import format from 'date-fns/format';
  import OddVerThTable from '@/components/tables/OddVerThTable';
  import EvenVerThTable from '@/components/tables/EvenVerThTable';
  import KYCModal from '@/components/modals/KYCModal';
  import AnalyticsReportModal from '@/components/modals/AnalyticsReportModal';
  import PersonalInfoStatementModal from '@/components/modals/PersonalInfoStatementModal';
  import { relationship as relationshipOptions,accidentrelationship } from '@/staticData/selectOptions';
  import { GET_OTP_ACTION } from '@/store/modules/user/constants';
  import { log } from '@/utils/axios';

  export default {
    components: { 
      OddVerThTable,
      EvenVerThTable,
      KYCModal,
      AnalyticsReportModal,
      PersonalInfoStatementModal,
      Button,
      Checkbox,
      Spin
    },
    props: {
      insuType: {
        type: String,
        default: 'car'
      },
    },
    data() {
      return {
        docs: {
          kyc: {
            label: '消費者網路投保需求聲明事項(KYC)',
            isAgree: false,
            modal: false
          },
          analytics: {
            label: '磐石保經為我這次投保所整理的書面分析報告',
            isAgree: false,
            modal: false
          },
          statement: {
            label: '個資告知聲明事項',
            isAgree: false,
            modal: false
          }
        },
        relationshipOptions
      }
    },
    computed: {
      ...mapState({
        checkout: ({ checkout }) => checkout,
        phoneNo: ({ user }) => user.profile.phoneNo
      }),
      insuPeriod() {
        const { insuPeriod } = this.checkout.travelInsuInfo;
        return insuPeriod;
      },
      AccidentinsuPeriod() {
        const { AccidentinsuPeriod } = this.checkout.accidentInsuInfo;
        return AccidentinsuPeriod;
      },
      PetinsuPeriod(){
        const { PetinsuPeriod } = this.checkout.petInsuInfo;
        return PetinsuPeriod;
      },
      agreeAll() {
        return Object.keys(this.docs)
          .find(key => this.docs[key].isAgree === false) === undefined;
      },
      insuInfoBasic() {
        let data = [];
        let company= [];
        let product = [];
        let productIsCompulsory = [];
        let insuTime = [];
        let details = [];
        let orderTime = format(new Date(), 'YYYY / MM / DD');
        this.checkout.insuInfos.filter((info) => {
          company.push(info.insuCompany);
          productIsCompulsory.push(info.isCompulsory);
          let productName = `${info.insuCompany}-${info.insuName}`
          product.push(productName);
        });
        this.checkout.quotes.details.filter((detail) => {
          details.push(detail.title);
        });
        const InsuCompanyUrl=this.checkout.quotes;
        const insuCompany = [...(new Set(company))][0];
        const insuName = product.join('、');
        const insusDetail = details.join('、');
        const premiums = `${this.checkout.quotes.total}元`;
        const { insuPeriod } = this;
        //console.log("insuPeriod:"+insuPeriod);
        const { AccidentinsuPeriod } = this;  //20201203 Wen Add 傷害險
         //console.log("AccidentinsuPeriod:"+AccidentinsuPeriod);
        const { PetinsuPeriod } = this;    //20210503 Wen Add 寵物險
         //console.log("PetinsuPeriod:"+PetinsuPeriod);        
        switch (this.insuType) {
          case 'car':
            productIsCompulsory.filter((pclass) => {
              if(pclass) {
                let start = this.checkout.infoOfCar.inceptionDate.compulsory;
                let end = (parseInt(start.split('-')[0])+1) + start.slice(4);
                insuTime.push(`強制險: (1年期) ${start} ~ ${end}`);
              }
              else{
                let comstart = this.checkout.infoOfCar.inceptionDate.compulsory;
                let comend = (parseInt(comstart.split('-')[0])+1) + comstart.slice(4);
                insuTime.push(`強制險: (1年期) ${comstart} ~ ${comend}`);  //2020/5/18 Wen Add
                let start = this.checkout.infoOfCar.inceptionDate.arbitrary;
                let end = (parseInt(start.split('-')[0])+1) + start.slice(4);
                insuTime.push(`任意險: (1年期) ${start} ~ ${end}`);
              }                
            });  
            data = [
              { title: '保險公司', content: insuCompany},
              { title: '投保商品', content: insuName },
              { title: '險種', content: insusDetail },
              { title: '投保期間', content: insuTime.join('|') },
              { title: '保費金額', content: premiums },
              { title: '承保日期', content: orderTime },
            ]          
            break;
          case 'motor':
            productIsCompulsory.filter((pclass) => {
              if(pclass) {
                let start = this.checkout.infoOfMotor.inceptionDate.compulsory;
                let end = (parseInt(start.split('-')[0])+1) + start.slice(4);
                insuTime.push(`強制險:1年期: ${start} - ${end}`);
              }
              else{
                let comstart = this.checkout.infoOfMotor.inceptionDate.compulsory;
                let comend = (parseInt(comstart.split('-')[0])+1) + comstart.slice(4);
                insuTime.push(`強制險: (1年期) ${comstart} ~ ${comend}`);  //2020/5/18 Wen Add

                let start = this.checkout.infoOfMotor.inceptionDate.arbitrary;
                let end = (parseInt(start.split('-')[0])+1) + start.slice(4);
                insuTime.push(`任意險:1年期: ${start} - ${end}`);
              }                
            });  
            data = [
              { title: '保險公司', content: insuCompany},
              { title: '投保商品', content: insuName },
              { title: '險種', content: insusDetail },
              { title: '投保期間', content: insuTime.join('|') },
              { title: '保費金額', content: premiums },
              { title: '承保日期', content: orderTime },
            ]   
            break;
          case 'travel':
            data = [
              { title: '保險公司', content: insuCompany},
              { title: '投保商品', content: insuName },
              { title: '險種', content: insusDetail },
              { title: '投保期間', content: insuPeriod },
              { title: '保費金額', content: premiums },
              { title: '承保日期', content: orderTime },
            ]   
            break;
          case 'accident':
          // let start = this.checkout.infoOfAccident.accidentFilter.accidentdate.date;
           //     let end = (parseInt(start.split('-')[0])+1) + start.slice(4);
           //     insuTime.push(`傷害險:1年期: ${start} - ${end}`);
            data = [
              { title: '保險公司', content: insuCompany},
              { title: '投保商品', content: insuName },
              { title: '險種', content: insusDetail },
              { title: '投保期間', content: AccidentinsuPeriod },
              { title: '保費金額', content: premiums },
              { title: '承保日期', content: orderTime },
            ]   
            break;
          case 'pet':
            data = [
              { title: '保險公司', content: insuCompany},
              { title: '投保商品', content: insuName },
              { title: '險種', content: insusDetail },
              { title: '投保期間', content: PetinsuPeriod },
              { title: '保費金額', content: premiums },
              { title: '承保日期', content: orderTime },
            ]   
            break;
          default:
          data = [
              { title: '保險公司', content: insuCompany},
              { title: '投保商品', content: insuName },
              { title: '險種', content: insusDetail },
              { title: '投保期間', content: insuPeriod },  //20210530 Wen Add
              { title: '保費金額', content: premiums },
              { title: '承保日期', content: orderTime },
            ]   
            break;
        }
        return data;
      },
      insuInfoUser() {
        let data = [];
        let name,phone,birth,address,identityNo,email;
        switch (this.insuType) {
          case 'car':
            name = Object.values(this.checkout.infoOfCar.userProfile.name).join('');
            phone = `${this.checkout.infoOfCar.userProfile.phoneNo}`;
            birth = Object.values(this.checkout.infoOfCar.userProfile.dateOfBirth).join(' / ');
            address = Object.values(this.checkout.infoOfCar.userProfile.address).join('').slice(0,-3);
            identityNo = `${this.checkout.infoOfCar.userProfile.identityNo}`;
            data = [
              { title: '姓名', content: name},
              { title: '生日', content: birth },
              { title: '行動電話', content: phone },
              { title: '身分證字號', content: identityNo },
              { title: '通訊地址', content: address },
            ]
            break;
          case 'motor':
            name = Object.values(this.checkout.infoOfMotor.userProfile.name).join('');
            phone = `${this.checkout.infoOfMotor.userProfile.phoneNo}`;
            birth = Object.values(this.checkout.infoOfMotor.userProfile.dateOfBirth).join(' / ');
            address = Object.values(this.checkout.infoOfMotor.userProfile.address).join('').slice(0,-3);
            identityNo = `${this.checkout.infoOfMotor.userProfile.identityNo}`;
            data = [
              { title: '姓名', content: name},
              { title: '生日', content: birth },
              { title: '行動電話', content: phone },
              { title: '身分證字號', content: identityNo },
              { title: '通訊地址', content: address },
            ]
            break;
          case 'travel':
            name = Object.values(this.checkout.infoOfTravel.userProfile.name).join('');
            phone = `${this.checkout.infoOfTravel.userProfile.phoneNo}`;
            birth = Object.values(this.checkout.infoOfTravel.userProfile.dateOfBirth).join(' / ');
            address = Object.values(this.checkout.infoOfTravel.userProfile.address).join('').slice(0,-3);
            identityNo = `${this.checkout.infoOfTravel.userProfile.identityNo}`;
            email = `${this.checkout.infoOfTravel.userProfile.mail}`;
            data = [
              { title: '姓名', content: name},
              { title: '生日', content: birth },
              { title: '行動電話', content: phone },
              { title: '身分證字號', content: identityNo },
              { title: '通訊地址', content: address },
              { title: 'Email', content: email },
            ]
            break;
          case 'accident':
            name = Object.values(this.checkout.infoOfAccident.userProfile.name).join('');
            phone = `${this.checkout.infoOfAccident.userProfile.phoneNo}`;
            birth = Object.values(this.checkout.infoOfAccident.userProfile.dateOfBirth).join(' / ');
            address = Object.values(this.checkout.infoOfAccident.userProfile.address).join('').slice(0,-3);
            identityNo = `${this.checkout.infoOfAccident.userProfile.identityNo}`;
            email = `${this.checkout.infoOfAccident.userProfile.mail}`;
            data = [
              { title: '姓名', content: name},
              { title: '生日', content: birth },
              { title: '行動電話', content: phone },
              { title: '身分證字號', content: identityNo },
              { title: '通訊地址', content: address },
              { title: 'Email', content: email },
            ]
            break;
          case 'pet':
            name = Object.values(this.checkout.infoOfPet.userProfile.name).join('');
            phone = `${this.checkout.infoOfPet.userProfile.phoneNo}`;
            birth = Object.values(this.checkout.infoOfPet.userProfile.dateOfBirth).join(' / ');
            address = Object.values(this.checkout.infoOfPet.userProfile.address).join('').slice(0,-3);
            identityNo = `${this.checkout.infoOfPet.userProfile.identityNo}`;
            email = `${this.checkout.infoOfPet.userProfile.mail}`;
            data = [
              { title: '姓名', content: name},
              { title: '生日', content: birth },
              { title: '行動電話', content: phone },
              { title: '身分證字號', content: identityNo },
              { title: '通訊地址', content: address },
              { title: 'Email', content: email },
            ]
            break;
            case 'vaccine':
            name = Object.values(this.checkout.infoOfVaccine.userProfile.name).join('');
            phone = `${this.checkout.infoOfVaccine.userProfile.phoneNo}`;
            birth = Object.values(this.checkout.infoOfVaccine.userProfile.dateOfBirth).join(' / ');
            address = Object.values(this.checkout.infoOfVaccine.userProfile.address).join('').slice(0,-3);
            identityNo = `${this.checkout.infoOfVaccine.userProfile.identityNo}`;
            email = `${this.checkout.infoOfVaccine.userProfile.mail}`;
            data = [
              { title: '姓名', content: name},
              { title: '生日', content: birth },
              { title: '行動電話', content: phone },
              { title: '身分證字號', content: identityNo },
              { title: '通訊地址', content: address },
              { title: 'Email', content: email },
            ]
            break;
        }
        return data;
      },
      insuInfoOfMore() {
        let data = [];
        let carNo,carType,exFactoryDate,carLicenseDate,cc,brand,carStyle,engineNo,maxPassengers;
        let relationshipNo,relationship,name,identityNo,birth,address,phoneNo
        switch (this.insuType) {
          case 'car':
            carNo = Object.values(this.checkout.infoOfCar.carProfile.carNo).join(' - ').slice(0,-5);
            brand = this.checkout.carInfo.brandName;
            carType = this.checkout.carInfo.typeName;
            carStyle = this.checkout.carInfo.styleName;
            exFactoryDate = Object.values(this.checkout.infoOfCar.carProfile.exFactoryDate).join(' / ');
            engineNo = `${this.checkout.infoOfCar.carProfile.engineNo}`;
            carLicenseDate = Object.values(this.checkout.infoOfCar.carProfile.carLicenseDate).join(' / ');
            maxPassengers = `${this.checkout.infoOfCar.carProfile.maxPassengers}`;
            cc = `${this.checkout.infoOfCar.carProfile.cc} C.C`;
            data = [
              { title: '牌照號碼', content: carNo },
              { title: '廠牌', content: brand },
              { title: '車種', content: carType },
              { title: '車系車型', content: carStyle },
              { title: '出廠年份', content: exFactoryDate },
              { title: '引擎號碼', content: engineNo },
              { title: '發照日期', content: carLicenseDate },
              { title: '乘載人數', content: maxPassengers },
              { title: '排氣量', content: cc },
            ]
          break;
          case 'motor':
            carNo = Object.values(this.checkout.infoOfMotor.carProfile.carNo).join(' - ').slice(0,-5);
            brand = this.checkout.carInfo.brandName;
            carType = this.checkout.carInfo.typeName;
            carStyle = this.checkout.carInfo.styleName;
            exFactoryDate = Object.values(this.checkout.infoOfMotor.carProfile.exFactoryDate).join(' / ');
            engineNo = `${this.checkout.infoOfMotor.carProfile.engineNo}`;
            carLicenseDate = Object.values(this.checkout.infoOfMotor.carProfile.carLicenseDate).join(' / ');
            cc = `${this.checkout.infoOfMotor.carProfile.cc} C.C`;
            data = [
              { title: '牌照號碼', content: carNo },
              { title: '廠牌', content: brand },
              { title: '車種', content: carType },
              { title: '車系車型', content: carStyle },
              { title: '出廠年份', content: exFactoryDate },
              { title: '引擎號碼', content: engineNo },
              { title: '發照日期', content: carLicenseDate },
              { title: '排氣量', content: cc },
            ]
          break;
          case 'travel':
            relationshipNo = `${this.checkout.infoOfTravel.beneficiaryProfile.relationship}`;
            name = Object.values(this.checkout.infoOfTravel.beneficiaryProfile.name).join('');
            identityNo = `${this.checkout.infoOfTravel.beneficiaryProfile.identityNo}`;
            birth = Object.values(this.checkout.infoOfTravel.beneficiaryProfile.dateOfBirth).join(' / ');;
            address = Object.values(this.checkout.infoOfTravel.beneficiaryProfile.address).join('');;
            phoneNo = `${this.checkout.infoOfTravel.beneficiaryProfile.phoneNo}`;
            relationship = relationshipOptions.filter(options => {
              return options.value === relationshipNo;
            })
            if(relationshipNo === '10') {

              data = [
                { title: '關係', content: relationship[0].label },
              ]
            }else{
              data = [
                { title: '關係', content: relationship[0].label },
                { title: '姓名', content: name },
                { title: '身分證字號', content: identityNo },
                { title: '生日', content: birth },
                { title: '通訊地址', content: address },
                { title: '行動電話', content: phoneNo },
              ]
            }
          break;
        case 'accident':
            relationshipNo = `${this.checkout.infoOfAccident.accidentbeneficiaryProfile.relationship}`;
            name = Object.values(this.checkout.infoOfAccident.accidentbeneficiaryProfile.name).join('');
            identityNo = `${this.checkout.infoOfAccident.accidentbeneficiaryProfile.identityNo}`;
            birth = Object.values(this.checkout.infoOfAccident.accidentbeneficiaryProfile.dateOfBirth).join(' / ');;
            address = Object.values(this.checkout.infoOfAccident.accidentbeneficiaryProfile.address).join('');;
            phoneNo = `${this.checkout.infoOfAccident.accidentbeneficiaryProfile.phoneNo}`;
            relationship = relationshipOptions.filter(options => {
              return options.value === relationshipNo;
            })
            if(relationshipNo === '10') {

              data = [
                { title: '關係', content: relationship[0].label },
              ]
            }else{
              data = [
                { title: '關係', content: relationship[0].label },
                { title: '姓名', content: name },
                { title: '身分證字號', content: identityNo },
                { title: '生日', content: birth },
                { title: '通訊地址', content: address },
                { title: '行動電話', content: phoneNo },
              ]
            }
          break;  
          case 'pet':
            /*relationshipNo = `${this.checkout.infoOfPet.petBeneficiaryProfile.relationship}`;
            name = Object.values(this.checkout.infoOfPet.petBeneficiaryProfile.name).join('');
            identityNo = `${this.checkout.infoOfPet.petBeneficiaryProfile.identityNo}`;
            birth = Object.values(this.checkout.infoOfPet.petBeneficiaryProfile.dateOfBirth).join(' / ');;
            address = Object.values(this.checkout.infoOfPet.petBeneficiaryProfile.address).join('');;
            phoneNo = `${this.checkout.infoOfPet.petBeneficiaryProfile.phoneNo}`;
            relationship = relationshipOptions.filter(options => {
              return options.value === relationshipNo;
            })
            if(relationshipNo === '10') {

              data = [
                { title: '關係', content: relationship[0].label },
              ]
            }else{
              data = [
                { title: '關係', content: relationship[0].label },
                { title: '姓名', content: name },
                { title: '身分證字號', content: identityNo },
                { title: '生日', content: birth },
                { title: '通訊地址', content: address },
                { title: '行動電話', content: phoneNo },
              ]
            }*/
          break;
          case 'vaccine':
          //console.log("vaccineBeneficiaryProfile++"+JSON.stringify(this.checkout.infoOfVaccine));
            relationshipNo = `${this.checkout.infoOfVaccine.vaccineBeneficiaryProfile.relationship}`;
            name = Object.values(this.checkout.infoOfVaccine.vaccineBeneficiaryProfile.name).join('');
            identityNo = `${this.checkout.infoOfVaccine.vaccineBeneficiaryProfile.identityNo}`;
            birth = Object.values(this.checkout.infoOfVaccine.vaccineBeneficiaryProfile.dateOfBirth).join(' / ');;
            address = Object.values(this.checkout.infoOfVaccine.vaccineBeneficiaryProfile.address).join('');;
            phoneNo = `${this.checkout.infoOfVaccine.vaccineBeneficiaryProfile.phoneNo}`;
            relationship = relationshipOptions.filter(options => {
              return options.value === relationshipNo;
            })
            if(relationshipNo === '10') {

              data = [
                { title: '關係', content: accidentrelationship[0].label },
              ]
            }else{
              data = [
                { title: '關係', content: accidentrelationship[0].label },
                { title: '姓名', content: name },
                { title: '身分證字號', content: identityNo },
                { title: '生日', content: birth },
                { title: '通訊地址', content: address },
                { title: '行動電話', content: phoneNo },
              ]
            }
          break;
        }
        return data;
      },
      blockTitleOfUser() {
        switch (this.insuType) {
          case 'car':
            return '車主資料';
          break;
          case 'motor':
            return '車主資料';
          break;
          case 'travel':
            return '要保人資料';
          break;
          case 'accident':
            return '要保人資料';
          break;
          case 'pet':
          return '要保人資料';
           break;
           case 'vaccine':
          return '要保人資料';
           break;
        }
      },
      blockTitleOfMore() {
        switch (this.insuType) {
          case 'car':
            return '車籍資料';
          break;
          case 'motor':
            return '車籍資料';
          break;
          case 'travel':
            return '受益人資料';
          break;
          case 'accident':
            return '受益人資料';
          break;
           case 'pet':
            return '';
          break;
          case 'vaccine':
            return '受益人資料';
          break;
        }
      }
    },
    methods: {
      async next() {
        const {
          $store,
          phoneNo
        } = this;
        Spin.show();
        const gotStatus = await $store.dispatch(GET_OTP_ACTION,{ phoneNo, type: 'checkout'});
        Spin.hide();
        if(gotStatus) {
          this.$router.push({ 
            name: 'checkoutVerify', 
            params: { 
              current: 2,
            }
          });
        }
      },
      back() {
        this.$router.push({ 
          name: 'checkoutQuotes',
          params: { 
            current: 1,
          }
        });
      },
      checkAfterRead(val, key) {
        if (val) {
          log({ 
            basketId: this.checkout.quotes.basketNum, 
            webUserIp: this.$store.state.user.ip,
            webProgramCodeId: 'CKC',
            webControlCodeId: 'RPO',
            webControlBefore: this.docs[key].label
          });
          this.docs[key].modal = true;
          this.docs[key].isAgree = true;
        }
      }
    }
  }
</script>